import React from 'react';
import { fonts } from '../theme';

const COLS = [
  { h: 'Care', items: ['Orthopaedic', 'Neurological', 'Paediatric', 'Geriatric', 'Post-op'] },
  { h: 'Visit', items: ['Clinic — Vadodara', 'Home visits', 'Booking', 'WhatsApp'] },
  { h: 'Reach', items: ['+91 6353 937 571', 'moxapatel1908@gmail.com', '@moksha.physio'] },
];

export default function DesktopFooter({ t }) {
  return (
    <div style={{ padding: '40px max(56px, 4vw)', background: t.ink, color: t.paper }}>
      <div style={{
        display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr', gap: 32,
        maxWidth: 1440, margin: '0 auto',
      }}>
        <div>
          <div style={{ fontFamily: fonts.serif, fontSize: 28, fontWeight: 300 }}>
            Dr. Moksha Patel{' '}
            <span style={{ fontStyle: 'italic', color: t.mint }}>(PT)</span>
          </div>
          <div style={{
            fontSize: 12, color: 'rgba(246,243,236,0.55)', marginTop: 12, maxWidth: 320,
          }}>
            A movement-first physiotherapy practice in Vadodara, Gujarat. License GPC-21250.
          </div>
        </div>
        {COLS.map(col => (
          <div key={col.h}>
            <div style={{
              fontFamily: fonts.mono, fontSize: 10, letterSpacing: '0.18em',
              textTransform: 'uppercase', color: t.mint, marginBottom: 16,
            }}>{col.h}</div>
            {col.items.map(i => (
              <div key={i} style={{
                fontSize: 12.5, color: 'rgba(246,243,236,0.7)', padding: '5px 0',
                wordBreak: 'break-word',
              }}>{i}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
